import router from './router'
import $x from '../js/$x'
import store from '../store/index'
import getMenuRoutesMap from './menuRoutesMap.js';
import getMainRoutes from './mainRoutes.js';
import oldRoute from './oldRoute';

var haveRouter, routerTabs;

router.afterEach((to, from, next) => {
    document.title = to.meta.title;
    store.dispatch('pushRoutePath', to);
})

router.beforeEach((to, from, next) => {
    if (!haveRouter) {
        //刷新页面或其他页面返回,只执行一次
        $x.post('home/getHomeUrl', {})
            .then(res => {
                haveRouter = true;
                routerTabs = res || [];
                router.addRoutes(getMainRoutes())
                //获取登录用户角色
                addDynamicRoutes(routerTabs)
                store.dispatch('setRouterTabs', res);
                next({ ...to, replace: true })
            })
    } else {
        let defaultPath = location.hash.slice(1) || '/';
        if (defaultPath === '/' && routerTabs[0]) {
            defaultPath = routerTabs[0].url
        }
        if (to.path === '/back') {
            var defaultRoute = { path: defaultPath, query: {} }
            var route = Object.assign(defaultRoute, $x.storage.getObj('jumpOutPars'))
            route.query.isBack = true;
            if (route.path === '/back') route.path = '/'; //避免堆栈溢出
            $x.storage.delObj('jumpOutPars')
            next(route)
            return
        }
        //返回时除了router.js不会触发任何状态监控，手动改变值触发页面变动
        if (to.meta.keepAlive) {
            store.dispatch('setScrollTop', store.state.scrollTop - 1)
        }
        if (to.path.indexOf('/okr') >= 0) {
            store.dispatch('setOkrTitle', '')
            if (to.query.title) {
                to.meta.title = to.query.title;
            }
        }
        //刷新页面或其他页面返回,只执行一次
        if (!$x.userInfo.account && to.path !== '/login') {
            $x.axios.doLogin()
        } else {
            //第一次登录进来时，退出登录时会清空
            const loginState = $x.storage.getObj('loginState');
            if (loginState == null && routerTabs.length) {
                $x.storage.setObj('loginState', 1)
                next({ path: defaultPath })
            } else {
                var newPath = oldRoute[to.path] //路由地址调整过，但需要兼容老的路由
                if (newPath) next({ ...to, path: newPath, replace: true })
                else next()
            }
        }
    }
})


function getRouter(routerTabs) {
    var routes = [];
    var map = getMenuRoutesMap(routerTabs)
    routerTabs.map(menu => {
        const url = menu.url;
        if (url && map[url.split('?')[0]]) {
            routes.push(...map[url.split('?')[0]])
        }
    });
    setTitleByTab(routes, routerTabs)
    return routes
}

function setTitleByTab(routes, routerTabs) {
    var titleMap = routerTabs.reduce((map, cur) => {
        map[cur.url] = cur.title;
        return map
    }, {})
    routes.map(route => {
        var tabTitle = titleMap[route.path]
        if (tabTitle) route.meta.title = tabTitle
    })
}

function addDynamicRoutes(routerTabs) {
    const routers = getRouter(routerTabs);
    router.addRoutes(routers);
    //动态添加路由后，打印出router.options.routes为空，需要手动赋值
    router.options.routes.push(...routers)
}

// router.afterEach((to) => {
//
// })

